import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
//Antd
import { Popconfirm, Modal, Card } from "antd";
import { Button, Form, Layout, Spin } from "antd";
import { IdcardOutlined, InfoCircleFilled } from "@ant-design/icons";
//Components
import { InfoPersonalPage } from ".";
import { ModalLogin } from "../../../components/Public/Login/ModalLogin";
import { ModalPrivacidad } from "../../../components/Public/Aspirante";
//Ducks
import * as catalogo from "../../../redux/aspirante/catalogoDucks";
import * as ducks from "../../../redux/aspirante/aspiranteDucks";
import * as userDuck from "../../../redux/usuario/usuarioDucks";
//Utils
import * as func from "../../../utils";
import * as uiText from "../../../utils";
import { linksRouter } from "../../../config/RouterLink";
import moment from "moment-timezone";
import { DATE_FORMAT_EXP } from "../../../utils";

/**
 * Pantalla principal del registro de aspirantes.
 * @export
 * @return {JSX.Element}
 */
export const RegistroMainPage = () => {
  const isMounted = useRef(true);
  //HOOKS
  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  //STATE-REDUX
  const { loading } = useSelector((state) => state.aspirante);
  //Validacion de campos email. rfc, curp y clave fuar
  const { isValidRfc } = useSelector((state) => state.aspirante.rfc);
  const { isValidCurp } = useSelector((state) => state.aspirante.curp);
  const { isValidClave } = useSelector((state) => state.aspirante.clave);
  const { isValidCorreo } = useSelector((state) => state.aspirante.correo);
  const { autenticado } = useSelector((store) => store.usuarioLogin);
  const { isSaved, isError, mensaje } = useSelector(
    (state) => state.aspirante.formulario
  );
  const { get_registro, get_FechaPostulacion } = useSelector(
    (state) => state.sistemas
  );

  // --------------------- useEffects   --------------------------------
  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    if (isMounted.current) {
      window.scrollTo(0, 0);
      dispatch(ducks.cleanAspirante());
      //Se obtiene la información del aviso de privacidad
      dispatch(catalogo.getTextAvisoPrivacidad());      
      // if (get_FechaPostulacion != null && get_registro != null && get_registro.valorConfiguracion === "0"){

      //   validaFecha();
      // }
    }

    return () => {
      isMounted.current = false; //Desmontar el componente
      dispatch(ducks.cleanAspirante());
      dispatch(catalogo.cleanCatalogo());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //useEffect que valida si hubo un error al registrar el aspirante o se guardó correctamente.
  useEffect(() => {
    isMounted.current && validaFormulario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, isSaved, mensaje]);

  useEffect(() => {
    if (isMounted.current && autenticado) {
      history.push({ pathname: linksRouter.home, state: { register: false } });
    } else {
      dispatch(userDuck.cleanUsuario());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autenticado]);

  useEffect(() => {
    if (
      get_registro !== null &&
      get_registro !== undefined &&
      get_registro.valorConfiguracion === "0"
    ) {
      history.push({ pathname: linksRouter.home, state: { register: false } });
      console.log("redirige ");
    } else {
      dispatch(userDuck.cleanUsuario());
    }
    // eslint-disable-next-line
  }, [get_registro]);

  useEffect(() => {
    if (get_FechaPostulacion !== null && get_FechaPostulacion !== undefined) {
      var fechaValida = validaFecha();
      console.log("fecha valida ", fechaValida);
      if (fechaValida !== false) {
        history.push({
          pathname: linksRouter.home,
          state: { register: false },
        });
      } else {
        dispatch(userDuck.cleanUsuario());
      }
    }
    // eslint-disable-next-line
  }, [get_FechaPostulacion]);

  // --------------------- Fin useEffects   ----------------------------

  /**
   * Función que muestra el modal de respuesta cuando se mande a registrar el aspirante
   * @returns Modal success o error
   */
  const validaFormulario = () => {
    if (isSaved) {
      Modal.success({
        title: "Éxito",
        okText: "Aceptar",
        keyboard: false,
        content: (
          <div>
            <p>{mensaje} En un momento se iniciará su sesión.</p>
          </div>
        ),
        onOk() {
          const user = form.getFieldValue("email");
          const password = form.getFieldValue("password");
          dispatch(ducks.setLoading(true));
          dispatch(userDuck.getUsuarioLogin(user, password)).then(() => {
            dispatch(ducks.setLoading(false));
            dispatch(ducks.cleanAspirante());
          });
        },
      });
    }
    //Si hubo un error al momento de registrar se muestra el mensaje
    if (isError) {
      func.openModalError(uiText.ERROR, mensaje);
      dispatch(ducks.setFormularioClean());
    }
  };

  /**
   * Función que manda a guardar los datos del aspirante.
   */
  const saveForm = () => {
    form
      .validateFields()
      .then((values) => {
        if (validaDatosPersonales() && func.validaInfoPersonal(values)) {
          let jsonForm = func.trimObjectJson(values);
          jsonForm.fechaNacimiento = func.formatFecha(
            jsonForm.fechaNacimiento,
            uiText.DATE_FORMAT
          );
          dispatch(ducks.saveAspirante(jsonForm));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const validaDatosPersonales = () => {
    if (!isValidCorreo) {
      form.scrollToField("email");
      return false;
    }
    if (!isValidRfc) {
      form.scrollToField("rfc");
      return false;
    }
    if (!isValidCurp) {
      form.scrollToField("curp");
      return false;
    }
    if (!isValidClave) {
      form.scrollToField("claveElector");
      return false;
    }
    return true;
  };

  const validaFecha = () => {
    if (get_FechaPostulacion !== null && get_FechaPostulacion !== undefined) {
      const { fechaInicio, fechaFin } = get_FechaPostulacion;
      const hoy = new Date(moment().format(DATE_FORMAT_EXP));
      const startDate = new Date(moment(fechaInicio).format(DATE_FORMAT_EXP));
      const endDate = new Date(moment(fechaFin).format(DATE_FORMAT_EXP));

      //Si la fecha actual es menor a la fecha inicio se bloquea el botón
      if (hoy < startDate) return true;
      //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
      if (hoy >= startDate && isNaN(endDate.getTime())) {
        console.log("segundo console");
        return false;
      }
      //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
      //Si ya pasaron las fechas y el estatus se encuentra en 1, solo se bloquea el botón
      return hoy >= startDate && hoy <= endDate ? false : true;
    }
  };

  return (
    <Spin size="large" spinning={loading}>
      {/* MODAL DE AVISO DE PRIVACIDAD */}
      <ModalPrivacidad />
      <Layout className="site-layout">
        <div className="site-layout-content">
          {/* Modl para inciar sesión desde el portal */}
          <ModalLogin />
          {/* Iniciar sesión */}
          <div>
            <div className="info-aspirante">
              Información de la persona aspirante
            </div>
            <div className="info-captura">Captura la siguiente información</div>

            <div className="alert-info">
              <InfoCircleFilled style={{ color: "#91d5ff", fontSize: 15 }} />
              &nbsp;
              {uiText.INFO_REV_1}
            </div>
          </div>

          {/* Contenedor Steps */}
          <div className="caja-steps">
            <Card className="card-info-peronal">
              <div className="card-info-title">
                <IdcardOutlined style={{ color: "#d5007f" }} /> Informacion
                personal
              </div>
            </Card>

            {/* Contenido para mostrar */}
            <div className="steps-content">
              <Form form={form} layout="vertical">
                <InfoPersonalPage form={form} />
              </Form>
              {/* Botones de navegación */}
              <div className="steps-action">
                <Popconfirm
                  title={uiText.INFO_REGISTRAR}
                  onConfirm={saveForm}
                  okText="Continuar"
                  cancelText="Cancelar"
                  id="valida-pop"
                >
                  <Button type="primary">Crear cuenta</Button>
                </Popconfirm>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Spin>
  );
};
